import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home.vue'
import mainLayout from '@/components/mainLayout'
import playLayout from '@/components/playLayout'
import adminLayout from '@/components/adminLayout'
import resList from './views/resList.vue'
import myList from './views/myList.vue'
import login from './views/login/index.vue'

import courseIndex from './views/course/index.vue'
import courseDetail from './views/course/detail.vue'
import resourceDetail from './views/resource/detail.vue'
import courseEdit from './views/course/edit.vue'
import courseMy from './views/course/my.vue'
import classIndex from './views/class/index.vue'
import classJump from './views/class/jump.vue'
import classHeader from './views/class/header.vue'

// 后台管理部分页面
// import Content from './views/admin/content.vue'
import Install from './views/admin/install.vue'
import Iinstalldev from './views/admin/iinstall_dev.vue'
import Installdevresource from './views/admin/iinstall_dev_resource.vue'
import Account from './views/admin/account.vue'
import Binding from './views/admin/student/binding.vue'
import Bindingclients from './views/admin/binding_clients.vue'
import Study from './views/admin/study.vue'
import StudyHistoryData from './views/admin/studyHistoryData.vue'
import ResourceList from './views/admin/resourceList.vue'
import ResourceUpload from './views/admin/resourceUpload.vue'

// 学生管理

import StudentList from './views/admin/student/studentList.vue'

// 设备绑定
import ClientList from './views/admin/client/clientList.vue'
import ClientGroup from './views/admin/client/clientGroup.vue'
import ClientConfigList from './views/admin/client/clientConfigList.vue'

// 课程播控
import PlayIndex from './views/play/play.vue'

// 激活
import Activation from './views/activation/activation.vue'

Vue.use(Router)

/// 若某个页面不需要登录，请把 meta 标示为 unauth: true

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      redirect: { name: 'courseIndex' }
    },

    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        unauth: true
      }
    },

    {
      path: '/activation/:account/:code',
      name: 'activation',
      component: Activation,
      meta: {
        unauth: true
      }
    },

    {
      path: '/about',
      name: 'about',
      component: () => import('./views/about.vue')
    },

    {
      path: '',
      component: mainLayout,
      children: [
        // 云端课程
        {
          path: '/course',
          name: 'courseIndex',
          component: courseIndex
        },

        // 课程详情（课程预览）
        {
          path: '/course/detail/:id/:type',
          name: 'courseDetail',
          component: courseDetail,
          props({ params: { id, type } }) {
            return {
              id: +id,
              type: +type
            }
          },
          meta: {
            nav: 'courseIndex',
            fullMain: true
          }
        },

        // 资源详情
        {
          path: '/resource/:id',
          name: 'resourceDetail',
          component: resourceDetail,
          props({ params: { id } }) {
            return { id: +id }
          },
          meta: {
            nav: 'courseIndex',
            fullMain: true
          }
        },

        // 创建 & 编辑课程
        {
          path: '/course/edit',
          name: 'courseEdit',
          component: courseEdit,
        },

        // 我的课程
        {
          path: '/course/my',
          name: 'courseMy',
          component: courseMy
        },
        {
          path: '/class/:id?/:resourceId?',
          name: 'classIndex',
          component: classJump,
          props({ params: { id, resourceId } }) {
            return {
              id: +id || 0,
              resourceId: +resourceId || 0
            }
          },
          meta: {
            fullMain: true
          }
        },

        // 课堂头部，仅用来以 iframe 嵌入嵌入其他页
        {
          path: '/class-header',
          name: 'classHeader',
          component: classHeader,
          meta: {
            fullMain: true,
            nav: 'classIndex',
            embed: true
          }
        },

        // 下面的页面会被重构掉
        {
          path: '',
          component: playLayout,
          children: [
            {
              path: '/res/list',
              name: 'resList',
              component: resList
            },

            {
              path: '/my/list',
              name: 'myList',
              component: myList
            }
          ]
        }
      ]
    },
    // 后台管理
    {
      path: '',
      component: adminLayout,
      children: [
        // 账户管理
        {
          path: '/account',
          name: 'account',
          component: Account
        },
        // 内容管理
        // {
        //   path: '/content',
        //   name: 'content',
        //   component: Content
        // },

        // 安装管理
        {
          path: '/install',
          name: 'install',
          component: Install
        },
        {
          path: '/installdev',
          name: 'installdev',
          component: Iinstalldev
        },
        {
          path: '/installdev/resource/:id',
          name: 'installdevresource',
          component: Installdevresource,
          props({ params: { id } }) {
            return { id: +id }
          }
        },
        // 学生管理-教师列表
        {
          path: 'binding',
          name: 'binding',
          component: Binding
        },
        // 人机绑定-班级学生绑定
        {
          path: 'binding/clients/:id',
          name: 'bindingclients',
          component: Bindingclients,
          props({ params: { id } }) {
            return { id: +id }
          }
        },
        // 学习数据
        {
          path: 'study',
          name: 'study',
          component: Study
        },
        // 学习数据-历史数据
        {
          path: 'study/history/:id',
          name: 'studyHistoryData',
          component: StudyHistoryData
        },
        // 资源列表
        {
          path: 'resourceList',
          name: 'resourceList',
          component: ResourceList
        },
        // 资源上传
        {
          path: 'resourceList/resourceUpload/:id?',
          name: 'resourceListUpload',
          component: ResourceUpload
        },
        // 学生管理 学生列表
        {
          path: 'binding/studentList/:id/:class',
          name: 'bindingStudentList',
          component: StudentList
        },
        // 设备绑定 设备分组
        {
          path: 'client',
          name: 'client',
          component: ClientList
        },
        {
          path: 'client/clientGroup',
          name: 'clientGroup',
          component: ClientGroup
        },
        {
          path: 'client/clientList/:id',
          name: 'clientConfigList',
          component: ClientConfigList
        }


      ]
    },
    {
      path: '/play/:id',
      name: 'playIndex',
      component: PlayIndex
    }
  ]
})
